import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Field, Text } from '@metrisk/react_metrisk-components'

import './RewardTrackingOptIn.scss'

interface RewardTrackingOptInProps {
  value: string
  onChange: any
}

const RewardTrackingOptIn: React.FunctionComponent<RewardTrackingOptInProps> = (props) => {
  const intl = useIntl()

  return (
    <div className="reward-tracking-opt-in">
      <Field
        id="reward-tracking-opt-in"
        value={props.value}
        type={'select'}
        options={[
          { label: intl.formatMessage({ defaultMessage:'No' }), value: false },
          { label: intl.formatMessage({ defaultMessage: 'Yes' }), value: true },
        ]}
        onChange={props.onChange}
        fullWidth
      />
      <Text type={'P'} className="reward-tracking-opt-in__info">
      <FormattedMessage defaultMessage='By selecting ‘Yes’ you confirm you are happy for us to share your contact details with DPD for the purpose of
        Gift delivery tracking only.'/>
      </Text>
    </div>
  )
}

export default RewardTrackingOptIn
